import connectToStores from 'alt-utils/lib/connectToStores'
import { Button } from 'components'
import Close from 'material-ui/svg-icons/navigation/close'
import { NpsActions } from 'actions'
import { AnalyticsUtils } from 'utils'
import "./nps.scss"

export default class NpsContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  componentDidMount() {
    AnalyticsUtils.npsViewed()
  }

  onClose() {
    NpsActions.dismiss()
    AnalyticsUtils.npsDismissed()
  }

  onClickScore(score) {
    NpsActions.setScore(score)
    AnalyticsUtils.npsScored(score)
  }

  voteButtons() {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
      return <Button
        label={i + ""}
        key={i}
        buttonType="primary"
        className={"nps__button nps__button-" + i}
        onTouchTap={() => this.onClickScore(i)} />
    })
  }

  render() {
    return (
      <div className="nps">
        <div>
          <h4 className="nps__header">How likely are you to recommend Plug in SEO to a friend?</h4>
          <Close className="nps__close" color="#757575" onTouchTap={::this.onClose}/>
        </div>
        <div className="flex-center medium-spacing--top">
          <p className="nps__label">Not Likely</p>
          { this.voteButtons() }
          <p className="nps__label">Very Likely</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/NpsContainer.js